var convert = require('./convert'),
    func = convert('omitBy', require('../omitBy'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/fp/omitBy.js
// module id = 1124
// module chunks = 0